import styled from "styled-components";
import { IconButton } from "@mui/material";

const Container = styled.div`
  background-color: ${(props) => props.theme.color.background.primary};
  height: 56px;
  width: 100%;
  margin: 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const Logo = styled.img`
  padding: 16px;
`;

const ButtonsContainer = styled.div`
  width: 100%;
  padding-right: 8px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: end;
`;

const Spacer = styled.div`
  width: auto;
  margin-left: 64px;
  margin-right: 16px;
  border-top: 1px solid #7f7f86;
  opacity: 12%;
`;

const MenuIconButton = styled(IconButton)({
  "&.MuiIconButton-root": {
    mr: 1,
    color: (props) => props.theme.color.text.primary,
  },
});

export { Container, Logo, ButtonsContainer, MenuIconButton, Spacer };
